import { AdministrationTenantCompany } from '@centecomm/portal-service';

export enum AdministrationActions {
    SET_TENANT_COMPANIES = 'SET_TENANT_COMPANIES',
}

interface SetTenantCompaniesAction {
    type: typeof AdministrationActions.SET_TENANT_COMPANIES;
    payload: AdministrationTenantCompany[];
}

export type AdministrationActionTypes = SetTenantCompaniesAction;
